// extracted by mini-css-extract-plugin
export default {"colour":"FormatColoursPreview_colour__YnbRq","more":"FormatColoursPreview_more__cFO1M"};